import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { RootState } from '../../../store';
import { ExternalSupervisorInvitation } from '../../../store/types';

import { ExternalSupervisorInvitationStatus } from '../../../definitions/enums/externalSupervisorInvitation';
import { unauthenticatedPaths } from '../../../router/constants/route-paths';
import { AuthPageWrapper } from '../Wrapper/authPageWrapper/AuthPageWrapper';
import { SupervisorInvitationLanding } from './supervisorInvitationLanding/SupervisorInvitationLanding';
import { getInvitationById } from '../../../api/supervisor';
import { INITIAL_EXTERNAL_SUPERVISOR_INVITATION } from '../../../utils';

const SupervisorSignUp = () => {
    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.authentication
                .supervisorSignUp
    );
    const [invitation, setInvitation] = useState<ExternalSupervisorInvitation>(
        INITIAL_EXTERNAL_SUPERVISOR_INVITATION
    );

    const { invitationId } = useParams();

    const navigate = useNavigate();

    useEffect(() => {
        const getInvitationRequest = async () => {
            if (invitationId) {
                setInvitation(await getInvitationById(invitationId));
            }
        };
        getInvitationRequest().catch(toast.error);
    }, []);

    const isValidInvitation = () => {
        return (
            !!invitation?._id &&
            !!invitation?.status &&
            !!invitation.invitedBy?._id &&
            invitation.project?._id
        );
    };
    const isSavedInvitation = () => {
        return (
            isValidInvitation() &&
            invitation?.status === ExternalSupervisorInvitationStatus.saved
        );
    };
    const isPendingInvitation = () => {
        return (
            isValidInvitation() &&
            invitation?.status === ExternalSupervisorInvitationStatus.pending
        );
    };
    const isApprovedInvitation = () => {
        return (
            isValidInvitation() &&
            invitation?.status === ExternalSupervisorInvitationStatus.approved
        );
    };
    const isDeclinedOrNotInitializedInvitation = () => {
        return (
            isValidInvitation() &&
            (invitation?.status ===
                ExternalSupervisorInvitationStatus.declined ||
                invitation?.status ===
                    ExternalSupervisorInvitationStatus.notInitialized)
        );
    };

    return (
        <>
            {(!isValidInvitation() ||
                isDeclinedOrNotInitializedInvitation()) && (
                <AuthPageWrapper title={localization.invalidInvitation} />
            )}
            {isSavedInvitation() && (
                <SupervisorInvitationLanding invitation={invitation} />
            )}
            {isPendingInvitation() && (
                <AuthPageWrapper
                    title={localization.pendingInvitationTitle}
                    subtitle={localization.pendingInvitationSubtitle}
                />
            )}
            {isApprovedInvitation() && navigate(unauthenticatedPaths.signIn)}
        </>
    );
};

export default SupervisorSignUp;
